module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: this.$route.query.yanse == 1 ? 'apply-loan-container2' : 'apply-loan-container'
  }, [_c('section', {
    ref: "applyLoan",
    staticClass: "apply-loan"
  }, [(this.$route.query.yanse != 3) ? _c('div', {
    staticClass: "srot_grislge"
  }, [_c('el-steps', {
    attrs: {
      "active": this.$store.state[1].activeNum,
      "align-center": ""
    }
  }, [_c('el-step', {
    attrs: {
      "title": "步骤1",
      "description": ""
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "步骤2",
      "description": ""
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "步骤3",
      "description": ""
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "步骤4",
      "description": ""
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "步骤5",
      "description": ""
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view', {
    ref: "applyLoanRouterView",
    staticClass: "apply-loan__router-view"
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view', {
    ref: "applyLoanRouterView",
    staticClass: "apply-loan__router-view"
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-013ae9b7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ApplyLoan.vue
// module id = 1044
// module chunks = 1